const map = {
	"./120.svg": 92346,
	"./121.svg": 92471,
	"./122.svg": 89116,
	"./123.svg": 98657,
	"./124.svg": 19422,
	"./125.svg": 26379,
	"./126.svg": 32816,
	"./127.svg": 2197,
	"./128.svg": 23330,
	"./129.svg": 74623,
	"./130.svg": 14513,
	"./131.svg": 42988,
	"./All.svg": 51648,
	"./BEST_DEALS.svg": 24305,
	"./BEST_PRICES.svg": 13802,
	"./Combo.svg": 88683,
	"./GYOMU_SUPER.svg": 53880,
	"./NEW_PRODUCTS.svg": 27006,
	"./RECOMMENDED_FOR_YOU.svg": 63972,
	"./SUPER_SAVING.svg": 61213,
	"./ShopByBrand.svg": 35679,
	"./THUONG_HIEU_KAMEREO.svg": 65471,
	"./chefChoice.svg": 85206
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16189;